export default "__VITE_ASSET__CdGd81IG__"